import React from 'react';
import './ContextChipAtom.scss';

export interface ContextChipAtomProps {
  icon: string;
  label: string;
  loading?: boolean;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  buttonRef?: React.Ref<HTMLButtonElement>;
}

const ContextChipAtom: React.FC<ContextChipAtomProps> = ({
  icon,
  label,
  loading = false,
  onClick,
  className = '',
  buttonRef,
}) => {
  return (
    <button
      ref={buttonRef}
      className={`context-chip ${className}`}
      onClick={onClick}
      type="button"
      aria-haspopup="true"
      data-testid="context-chip"
    >
      {loading ? (
        <i className="pi pi-spin pi-spinner context-chip__icon" />
      ) : (
        <i className={`pi ${icon} context-chip__icon`} />
      )}
      <span className="context-chip__label">{label}</span>
      <i className="pi pi-chevron-down context-chip__chevron" />
    </button>
  );
};

export default ContextChipAtom;
